import MenuService from "../../core/components/menu/MenuService";
import MenuItem from "../../core/components/menu/MenuItem";
import i18n from './../../shared/i18n'
import Reports from "@/modules/reports/Reports";

const routes = [
  {
    path: 'reports',
    name: 'reports',
    component: Reports,
    meta: {
      requiresAuth: true
    }
  },
];

MenuService.addMenuItem(new MenuItem('/reports', i18n.t('Reports'), 6, 'chart-bar', [], 'report'));

export {routes}
